import ApiConnector from "../connector";

class LeadsActions {
  get = async (params) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.get(`/leads/`, { params });
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.fallback_message;
    }

    return result;
  };
  getOne = async (id) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.get(`/leads/${id}/`);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.fallback_message;
    }

    return result;
  };
  create = async (lead) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.post(`/leads/`, lead);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data;
    }

    return result;
  };
  update = async (lead) => {
    delete lead.author
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.patch(`/leads/${lead.id}/`, lead);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data;
    }

    return result;
  };
  delete = async (id) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.delete(`/leads/${id}/`);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.fallback_message;
    }

    return result;
  };
}

export default new LeadsActions();
